import type { AppRouter } from "@kwp/api/router";
import type { inferRouterOutputs } from "@trpc/server";
import { createContext, useContext, type ReactNode } from "react";

export type Me = inferRouterOutputs<AppRouter>["me"];
export type MyWorkspace = Me["workspaces"][number];

const MeContext = createContext<Me | null>(null);

/** The signed-in, enrolled user (`me` from the api); provided once the gate has loaded it. */
export function MeProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export function useMe(): Me {
  const me = useContext(MeContext);
  if (me === null) throw new Error("useMe outside MeProvider");
  return me;
}
